import * as React from 'react';

/**
 * Creates a React context with a companion hook that throws
 * if used outside of the context provider.
 *
 * @param displayName - Component name shown in error messages and React DevTools
 * @returns Tuple of [Context, useSafeContext]
 */
export function createSafeContext<T>(displayName: string) {
  const Context = React.createContext<T | null>(null);
  Context.displayName = displayName;

  function useSafeContext(): T {
    const ctx = React.useContext(Context);
    if (!ctx) {
      throw new Error(
        `${displayName} compound components must be used within <${displayName}>`,
      );
    }
    return ctx;
  }

  return [Context, useSafeContext] as const;
}
